<template>
  <div class="grid-schedule">
    <div class="day-title">{{ day.day === -1 ? '모든요일': days[day.day] }}</div>
    <div>
      <select v-model="day.possible_resv" class="input-border">
        <option :value="true">영업</option>
        <option :value="false">휴무</option>
      </select>
    </div>
    <div>
      <template v-if="day.possible_resv">
        <input class="input-border" type="number" placeholder="0" min="0"
          @keyup="e => day.stock = Number(e.target.value)" v-model="day.stock" style="text-align: left">
      </template>
      <template v-else>
        <input class="input-border" type="number" disabled>
      </template>
    </div>
    <div class="flex-align">
      <input class="input-border" type="number" placeholder="0" min="0"
        @keyup="e => day.price = Number(e.target.value)" v-model="day.price" :disabled="!day.possible_resv">
      <div class="size-14" style="margin-left:4px">원</div>
    </div>
    <div>
      <template v-if="day.possible_resv">
        <select v-model="day.discount_type" class="input-border">
          <option :value="-1">할인없음</option>
          <option :value="0">할인율</option>
          <option :value="1">금액할인</option>
        </select>
      </template>
      <template v-else>
        <input class="input-border" type="number" disabled>
      </template>
    </div>
    <div>
      <div v-if="!day.possible_resv || day.discount_type===-1" class="flex-align">
        <input type="number" class="input-border" disabled :value="0">
        <div style="width:17px"></div>
      </div>
      <div v-else-if="day.discount_type===0" class="flex-align">
        <input class="input-border" type="number" placeholder="0"
          min="0" @keyup="e => day.discount_rate = Number(e.target.value)" v-model="day.discount_rate">
        <div class="size-14" style="margin-left:4px">%</div>
      </div>
      <div v-else-if="day.discount_type===1" class="flex-align">
        <input class="input-border" type="number" placeholder="0"
          min="0" @keyup="e => day.discount_price = Number(e.target.value)" v-model="day.discount_price">
        <div class="size-14" style="margin-left:4px">원</div>
      </div>
    </div>
    <div class="size-14 weight-700">
      <span v-if="day.possible_resv && day.discount_type>-1">{{ calcDiscount(day)|currency }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ModalItemPriceSchedule',
    props: {
      day: {
        type: Object
      }
    },
    data() {
      return {
        days: ['월요일','화요일','수요일','목요일','금요일','토요일','일요일'],
      }
    },
    methods: {
      calcDiscount(item) {
        let price = 0;
        if(item.discount_type === 0) {
          price = item.price - (item.price * (item.discount_rate / 100))
        } else {
          price = item.price - item.discount_price;
        }
        return price;
      }
    },
    watch: {
      'day.discount_type'(n) {
        this.day.is_discount = n !== -1;
      }
    }
  }

</script>

<style lang="stylus" scoped>
  .grid-schedule
    display grid
    grid-template-columns 60px 80px 80px 200px 100px 150px 120px
    align-items center
    margin-bottom 20px

  .day-title
    font-size 14px
    font-weight 700

  .input-border
    border 1px solid #cccccc
    border-radius 4px
    padding 7px
    width 100%
    flex 1
  input[type=number]
    color #363636
</style>
